

























import { Component, Vue, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';
import { WorkordersApi } from 'performo-api';

@Component({
  components: { EditOnClickField },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    ordersApi: 'ordersApi'
  })
})
export default class StartDateEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: 'Start' })
  private label!: string;

  @Prop({ required: true, default: '' })
  private value!: Date | undefined;

  private startDateMode = 'read';
  private currentPropertyId!: string;
  private currentUser!: User;

  private updatedValue: Date | undefined = undefined;
  private loading!: boolean;

  private ordersApi!: WorkordersApi;

  data() {
    return { updatedValue: this.value, loading: false };
  }

  get valueUpdate() {
    return this.updatedValue || this.value;
  }
  set valueUpdate(val) {
    this.updatedValue = val;
  }

  private async handleStartDateChange(StartDate: Date) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === StartDate) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeStartDate({
        workorderId: this.workorderId,
        changeOrderStartDateTimeCommand: {
          newStartDate: StartDate
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    // finally exit
    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.startDateMode = 'read';
    this.loading = false;
  }
}
